import React from "react";
import { Controller, useFormContext, useFieldArray } from "react-hook-form";
import { BidFormInput, Facility } from "../types/type";
import { DISCOUNT_PLAN } from "../config/const";

const Discount: React.FC<{ facility: Facility, confirm: boolean }> = ({ facility, confirm }) => {
    const { control, watch } = useFormContext<BidFormInput>();
    const discount = watch(`conditions.${facility.id}.discount`);
    const { fields, append, remove } = useFieldArray({
        control,
        name: `conditions.${facility.id}.discount`,
    });

    const addDiscount = () => {
        append({
            type: '0',
            target: '',
            value: 0,
            unit: '円',
        });
    };

    return (
        <>
            <div className="mb-3">
                <label>
                    <img className="img img-fluid height-20 mr-1 mb-1" src="assets/images/other/icon-tag-green.svg" alt="tag" />
                    割引の設定
                </label>
                <hr className="mt-0 mb-2" />
            </div>
            {discount && discount.map((discount, i) => (
                <div
                    key={i}
                    className={`bg-white border p-3 mb-3 ${i > 0 ? "discount-container" : ""}`}>
                    <div className="row mx-0">
                        <div className="col-lg-5 my-auto pl-0 pr-2">
                            <div className="input-group">
                                <Controller
                                    name={`conditions.${facility.id}.discount.${i}.type`}
                                    control={control}
                                    disabled={confirm}
                                    render={({ field }) => (
                                        <select
                                            {...field}
                                            className="custom-select theme-form-select text-placeholder-color rounded-0"
                                            value={field.value || ""}
                                        >
                                            <option value="">割引プランを選択</option>
                                            {Object.entries(DISCOUNT_PLAN).map(([key, val]) => (
                                                <option key={key} value={key}>
                                                    {val}
                                                </option>
                                            ))}
                                        </select>
                                    )}
                                />
                            </div>
                        </div>

                        <div className="col-lg-6 my-auto px-0">
                            <Controller
                                name={`conditions.${facility.id}.discount.${i}.target`}
                                control={control}
                                disabled={confirm}
                                render={({ field }) => (
                                    <input
                                        {...field}
                                        type="text"
                                        className="form-control rounded-0 w-max-200 d-inline-block"
                                        placeholder="割引単位"
                                    />
                                )}
                            />
                            <span className="text-md">×</span>
                            <Controller
                                name={`conditions.${facility.id}.discount.${i}.value`}
                                control={control}
                                disabled={confirm}
                                render={({ field }) => (
                                    <input
                                        {...field}
                                        type="number"
                                        className="form-control rounded-0 w-max-100 d-inline-block mr-2"
                                        placeholder="割引値"
                                    />
                                )}
                            />
                            <div className="d-inline-block">
                                <div className="input-group">
                                    <Controller
                                        name={`conditions.${facility.id}.discount.${i}.unit`}
                                        control={control}
                                        disabled={confirm}
                                        render={({ field }) => (
                                            <select
                                                {...field}
                                                className="custom-select theme-form-select rounded-0 w-min-100"
                                            >
                                                <option value="%">%</option>
                                                <option value="円">円</option>
                                            </select>
                                        )}
                                    />
                                </div>
                            </div>
                        </div>

                        {!confirm && (
                            <div className="col-lg-1 my-auto px-0 text-right">
                                {i > 0 && (
                                    <button
                                        type="button"
                                        className="btn-close-discount btn"
                                        onClick={() => remove(i)}
                                    >
                                        <img
                                            className="img img-fluid height-25"
                                            src="assets/images/other/icon-cross-white-bg-ass-circle.svg"
                                            alt="Delete"
                                        />
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            ))}
            {!confirm &&
                <button
                    type="button"
                    className="btn btn-sm btn-theme btn-theme-custom-sm btn-primary px-3 rounded-pill mb-4 btn-add-discount"
                    onClick={addDiscount}
                >
                    割引を追加する
                </button>
            }

        </>
    );
}

export default Discount;